import styled from 'styled-components';
import { Typography } from 'antd';

import { PageContainer as PC } from 'styles/components';
import theme from 'styles/theme';

export const PageContainer = styled(PC)`
  background: ${theme.backgrounds.onboarding};
  padding-top: 80px;
`;

export const Content = styled(Typography.Text)`
  &&& {
    white-space: normal;

    a {
      text-decoration: underline;
    }

    h2 {
      margin-top: 20px;
    }

    li > p {
      margin-bottom: 0;
    }

    ul {
      list-style-type: disc;
      margin-bottom: 5px;
    }

    ul ul {
      list-style-type: circle;
    }

    ul ul ul {
      list-style-type: square;
    }
  }
`;
